<template>
  <div>
    <vx-card>
      <div class="flex h-12 mt-1 fit-height">
        <div class="w-2/3 fit-height">
          <vs-table :data="contatos" class="fit-height">

            <template slot="thead">
              <vs-th>Nome</vs-th>
              <vs-th>E-mail</vs-th>
              <vs-th>Telefone</vs-th>
              <vs-th>Data</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.nome">
                  {{ tr.nome }}
                </vs-td>
                <vs-td :data="tr.email">
                  {{ tr.email }}
                </vs-td>
                <vs-td :data="tr.telefone">
                  {{ tr.telefone }}
                </vs-td>
                <vs-td :data="tr.data">
                  {{ new Date(tr.data).toLocaleDateString() }}
                </vs-td>

                <template class="expand-user" slot="expand">
                  <div class="con-expand-users w-full">
                    <div class="">
                      <p><strong>Data:</strong><br />{{new Date(tr.data).toLocaleDateString('pt-BR') + ' ' + new Date(tr.data).toLocaleTimeString('pt-BR')}}</p><br />
                      <p><strong>Data:</strong><br />{{tr.assunto}}</p><br />
                      <p><strong>Mensagem:</strong><br /><span v-bind:key="index" v-for="(p, index) in tr.mensagem.split('\n')">{{p}}<br /></span></p>

                      <br />
                      <hr />
                      <br />

                      <vs-button type="border" size="medium" icon-pack="feather" icon="icon-edit-2" color="warning" v-on:click="editar(indextr)">Editar</vs-button>
                      <!-- <vs-button type="border" size="medium" icon-pack="feather" icon="icon-trash" color="danger" class="ml-4" v-on:click="remover(indextr)">Remover</vs-button> -->
                    </div>
                  </div>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div class="w-1/3 ml-10 fit-height" v-if="mostrarForm">
          <form v-on:submit.prevent="salvar" id="formulario">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label-placeholder="Nome" v-model="contato.nome" />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input type="email" class="w-full" icon-pack="feather" icon="icon-at-sign" icon-no-border label-placeholder="E-mail" v-model="contato.email" />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input type="text" class="w-full" icon-pack="feather" icon="icon-phone-call" icon-no-border label-placeholder="Telefone" v-model="contato.telefone" />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input type="text" class="w-full" icon-pack="feather" icon="icon-search" icon-no-border label-placeholder="Assunto" v-model="contato.assunto" />
            </div>
          </div>
          <br />
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-textarea label="Mensagem" v-model="contato.mensagem" />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input type="text" class="w-full" icon-pack="feather" icon="icon-search" icon-no-border label-placeholder="Data" :value="new Date(contato.data).toLocaleDateString('pt-BR') + ' ' + new Date(contato.data).toLocaleTimeString('pt-BR')" disabled />
            </div>
          </div>
          <br />
          <div class="vx-row">
            <div class="vx-col w-full">
              <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" type="submit">Salvar</button>
            </div>
          </div>
        </form>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contatos: [],
      contato: {
        nome: '',
        email: '',
        telefone: '',
        assunto: '',
        mensagem: '',
        data: ''
      },
      id: '',
      mostrarForm: false,
      index: -1
    }
  },
  methods: {
    editar: function(index) {
      this.contato = this.contatos[index];
      this.id = this.contatos[index]._id;
      this.index = index;
      this.mostrarForm = true;
    },
    salvar: function() {
      fetch(this.$API_URL + "/contato/" + this.id, {
        method: "POST",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(this.contato)
      })
      .then(response => response.json())
      .then(json => {
        this.contatos[this.index] = json.data;

        if (json.status == 'success') {
          this.entrada = {
            nome: '',
            email: '',
            telefone: '',
            assunto: '',
            mensagem: '',
            data: ''
          }
          this.mostrarForm = false;
          this.$vs.notify({
          title:'Sucesso!',
          text:'Salvo com sucesso.',
          color:'primary'})
        } else {
          this.$vs.notify({
          title:'Erro!',
          text:'Ocorreu um erro ao salvar.',
          color:'danger'})
        }

      });
    },
    getContatos: function() {
      fetch(this.$API_URL + "/contato", {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        })
      })
      .then(response => response.json())
      .then(json => {
        json.data.forEach(contato => {
          this.contatos.push(contato)
        })
      });
    }
    // remover: function(index) {
    //   fetch(this.$API_URL + "/fab/" + this.fabs[index]._id, {
    //     method: "DELETE",
    //     headers: new Headers({
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       'Authorization': 'Bearer ' + localStorage.getItem('token')
    //     })
    //   })
    //   .then(response => response.json())
    //   .then(json => {
    //     if (json.status == "success")
    //       this.fabs.splice(index, 1);
    //   });
    // }
  },
  mounted() {
    this.getContatos();
  }
}
</script>

<style scoped>
  .fit-height {
    height: fit-content !important;
  }
</style>
